import { Controller } from "stimulus"

// Bugfix 20 (#1389): een klein venster (native <dialog>) openen en sluiten,
// met een optioneel deel dat met een vinkje zichtbaar wordt. Klik op de
// achtergrond of Escape sluit het venster zonder iets op te slaan.
export default class extends Controller {
  static targets = ["dialog", "optioneel"]

  // #1915: een venster dat de server al open zet (data-modaal-bij-laden, voor
  // wie zonder JavaScript werkt) wordt een echt modaal venster met achtergrond.
  dialogTargetConnected(dialog) {
    if (!dialog.open || !dialog.hasAttribute("data-modaal-bij-laden")) return
    dialog.close()
    dialog.showModal()
  }

  open(event) {
    event?.preventDefault()
    this.element.querySelectorAll("details[open]").forEach((menu) => menu.removeAttribute("open"))
    this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  achtergrond(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  wissel(event) {
    this.optioneelTargets.forEach((el) => el.classList.toggle("hidden", !event.target.checked))
  }
}
